import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function MessageStack({ className, ...rest }) {
    return _jsx("div", { className: cn("fwfa-message-stack", className), ...rest });
}
//# sourceMappingURL=MessageStack.js.map